import './monserate/style';
import FormStructure from './monserate/form_structure';

export default FormStructure;